<div>
  <p *ngFor="let message of errorMessages">
    {{message}}
  </p>
</div>
